module.exports = __webpack_public_path__ + "static/media/image-card-1.13d4f07a.png";